import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { PLAN_ACCESS_OPTIONS } from 'Common/Constants/Constants'
import { PlanAccessSelectProps } from './Common.types'

export const PlanAccessSelect = ({
  showPlansOption,
  handleShowMyPlansDropdown,
  label = 'Plan access',
}: PlanAccessSelectProps) => (
  <FormControl fullWidth>
    <InputLabel id="access-type-select-label">{label}</InputLabel>
    <Select
      sx={{
        width: '200px',
      }}
      labelId="access-type-select-label"
      id="access-type-select"
      value={showPlansOption}
      label={label}
      onChange={handleShowMyPlansDropdown}
    >
      <MenuItem value={PLAN_ACCESS_OPTIONS['Generated by me']}>
        {PLAN_ACCESS_OPTIONS['Generated by me']}
      </MenuItem>
      <MenuItem value={PLAN_ACCESS_OPTIONS['Not generated by me']}>
        {PLAN_ACCESS_OPTIONS['Not generated by me']}
      </MenuItem>
      <MenuItem value={PLAN_ACCESS_OPTIONS['Generated by anyone']}>
        {PLAN_ACCESS_OPTIONS['Generated by anyone']}
      </MenuItem>
    </Select>
  </FormControl>
)
